module.exports = __webpack_public_path__ + "assets/kestrel.4e825bb8.svg";